module.exports = {"422826100":"高乐山镇","422826101":"忠堡镇","422826102":"坪坝营镇","422826103":"朝阳寺镇","422826104":"清坪镇","422826105":"唐崖镇","422826200":"丁寨乡","422826202":"活龙坪乡","422826203":"小村乡","422826204":"黄金洞乡","422826400":"大路坝区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/422826.json
// module id = 1645
// module chunks = 0